// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"Loading_loading-wrapper__1XuI0","loading-wrapper-item":"Loading_loading-wrapper-item__315dK","arrows":"Loading_arrows__1rida"};